import type Sortable from "sortablejs";
import { createReorderable } from "../shared/sortable-reorder";

// cmsSectionRail backs the editor rail's reorder + show/hide controls. It reads
// the live order + per-row visibility from the DOM (rows are server-rendered
// templ, not Alpine x-for, so labels/icons stay server-side) and emits the full
// section-order array through the editor's cms-image-changed autosave path.
//
// Each sortable row carries: [data-section-row] [data-section-id]
//   [data-section-variant] [data-section-heading-id], a [data-section-handle]
//   drag grip, and a per-row x-data="{ on }" reflecting :data-section-enabled.
// The container carries data-sections-target + data-sections-field.
export function cmsSectionRail() {
  return {
    _sortable: null as Sortable | null,
    init() {
      const el = (this as any).$el as HTMLElement;
      const list = el.querySelector("[data-section-list]") as HTMLElement | null;
      if (!list) return;
      this._sortable = createReorderable(list, {
        handle: "[data-section-handle]",
        draggable: "[data-section-row]",
        onEnd: () => this._emit(),
      });
      // Toggle events bubble from the per-row eye buttons.
      el.addEventListener("cms-section-toggle", () => this._emit());
    },
    destroy() {
      this._sortable?.destroy();
      this._sortable = null;
    },
    // Read the current order + visibility from the DOM and emit it.
    _emit() {
      const el = (this as any).$el as HTMLElement;
      const list = el.querySelector("[data-section-list]") as HTMLElement | null;
      if (!list) return;
      const target = el.getAttribute("data-sections-target") || "";
      const field = el.getAttribute("data-sections-field") || "sections";
      if (!target) return;
      const rows = Array.from(list.querySelectorAll<HTMLElement>("[data-section-row]"));
      const value = rows.map((r) => {
        const cfg: Record<string, unknown> = {
          id: r.getAttribute("data-section-id"),
          enabled: r.getAttribute("data-section-enabled") === "1",
        };
        const variant = r.getAttribute("data-section-variant");
        if (variant) cfg.variant = variant;
        const heading = r.getAttribute("data-section-heading-id");
        if (heading) cfg.heading_id = heading;
        return cfg;
      });
      el.dispatchEvent(
        new CustomEvent("cms-image-changed", {
          detail: { field, target, value },
          bubbles: true,
        }),
      );
    },
  };
}
